import { makeActionCreator } from '../../../utilities'
import { CameraAttachmentsConstants } from './cameraAttachments.constants'

export const saveImage = makeActionCreator(CameraAttachmentsConstants.SAVE_IMAGE)
export const setImage = makeActionCreator(CameraAttachmentsConstants.SET_IMAGE, 'image')
export const setName = makeActionCreator(CameraAttachmentsConstants.SET_NAME, 'name')
export const setCategory = makeActionCreator(CameraAttachmentsConstants.SET_CATEGORY, 'category')
export const resetCameraAttachmentsState = makeActionCreator(CameraAttachmentsConstants.RESET_STATE)
export const setCameraAttachmentsList = makeActionCreator(
  CameraAttachmentsConstants.SET_CAMERA_ATTACHMENTS_LIST,
  'cameraAttachments'
)
export const setDisableCameraButton = makeActionCreator(
  CameraAttachmentsConstants.SET_DISABLE_CAMERA_BUTTON,
  'disableCameraButton'
)
